import { DataView } from "primereact/dataview";
import { Image } from "primereact/image"
import ping from './sponsor_images/ping.webp'
import pingV from './sponsor_images/ping_vert.jpg'
import driver from './clubs_images/driver.png'
import w3 from './clubs_images/3w.png'
import w7 from './clubs_images/7w.png'
import h3 from './clubs_images/3h.png'
import i4 from './clubs_images/4i.png.webp'
import irons from './clubs_images/irons.png.webp'
import wedge from './clubs_images/wedge.png'
import putter from './clubs_images/putter.png.webp'
import { useTranslation } from 'react-i18next';


function Bag({ isMobile }) {
    const { t } = useTranslation();

    const bag = [
        {
            kind: "Driver",
            name: "PING G440 LST",
            description: `${t("driver desc")}`,
            picture: driver
        },
        {
            kind: "3 wood",
            name: "PING G440 MAX",
            description: `${t("3w desc")}`,
            picture: w3
        },
        {
            kind: "7 wood",
            name: "PING G440 MAX",
            description: `${t("7w desc")}`,
            picture: w7
        },
        {
            kind: "3 hybrid",
            name: "PING G440 MAX",
            description: `${t("3h desc")}`,
            picture: h3
        },
        {
            kind: "4 iron",
            name: "PING iDi Driving Iron",
            description: `${t("4i desc")}`,
            picture: i4
        },
        {
            kind: `${t("irons")}`,
            name: "PING i230 5-W",
            description: `${t("irons desc")}`,
            picture: irons
        },
        {
            kind: `${t("wedges")}`,
            name: "PING s259",
            description: `${t("wedges desc")}`,
            picture: wedge
        },
        {
            kind: "Putter",
            name: "PING PLD OSLO 3",
            description: `${t("putter desc")}`,
            picture: putter
        },
        {
            kind: "Ball",
            name: "Titleist ProV1",
            description: ""
        },

    ]

    const itemTemplate = (c) => {
        return (
            <div className="col-12 sm:col-6 lg:col-4 p-4">
                <div className="flex flex-column align-items-center text-center group">
                    {/* Category Label */}
                    <span className="text-primary-600 font-bold uppercase tracking-widest text-xs mb-1">
                        {c.kind}
                    </span>

                    {/* Image Container - No background, just floating */}
                    <div className="flex align-items-center justify-content-center my-3 transition-transform transition-duration-300 transform hover:scale-105"
                        style={{ height: '220px' }}>
                        <Image
                            src={c.picture ?? ""}
                            width={isMobile ? "180" : "240"}
                            alt={c.name}
                            imageStyle={{ objectFit: 'contain', filter: 'drop-shadow(0px 15px 10px rgba(0,0,0,0.15))' }}
                        />
                    </div>

                    {/* Product Info */}
                    <div className="font-black text-2xl text-primary-900 mb-2 uppercase italic">
                        {c.name}
                    </div>
                    <div className="text-700 line-height-3 max-w-20rem text-sm">
                        {c.description}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div style={{
            width: "100%",
            padding: "4rem 1rem",
            borderTop: "4px solid var(--primary-700)" // A thinner, more modern "accent" line
        }}>
            <div className="max-w-screen-xl mx-auto">

                <DataView
                    value={bag}
                    itemTemplate={itemTemplate}
                    layout="grid"
                    pt={{
                        content: {
                            style: { backgroundColor: "transparent", border: "none" }
                        },
                        grid: {
                            className: "flex justify-content-center"
                        }
                    }}
                />
            </div>
        </div>
    );
}
export default Bag;